import { connect } from 'react-redux'
import StreamerCard from './StreamerCard'
import { fetchSubscribers, fetchAddSubscriber } from '../cabinet/subscribers/subscriberActions'
import { fetchPurchasedGifts, fetchGiveGift } from '../cabinet/shop/shopActions'

// Applies filtering to active streams loaded from the server
const mapStateToProps = state => {

  return {
    streamers: state.streamerCards.streamers,
    myGifts: state.shop.gifts,
    isLoadingGifts: state.shop.isLoading,
    personId: state.authorization.personId,
    subscribers: state.subscribers.data,
    isLoadingSubscribers: state.subscribers.isLoading
  }
}

const mapDispatchToProps = dispatch => ({
  fetchSubscribers: (personId) => dispatch(fetchSubscribers(personId)),
  addSubscriber: (personId, subscriber) => dispatch(fetchAddSubscriber(personId, subscriber)),
  fetchMyGifts: (personId) => dispatch(fetchPurchasedGifts(personId)),
  giveGift: (ownerId, receiverId, giftId) => dispatch(fetchGiveGift(ownerId, receiverId, giftId))
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  fetchSubscribers: () => dispatchProps.fetchSubscribers(stateProps.personId),
  addSubscriber: subscriber => dispatchProps.addSubscriber(stateProps.personId, subscriber),
  fetchMyGifts: () => dispatchProps.fetchMyGifts(stateProps.personId),
  giveGift: (receiverId, giftId) => dispatchProps.giveGift(stateProps.personId, receiverId, giftId)
})

const StreamerCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(StreamerCard)
export default StreamerCardContainer
